import { createAction, props } from '@ngrx/store';
export namespace DepartmentActions {
  export enum Type {
    GET_ALL_DEPARTMENTS = '[DEPARTMENT] Get All Departments',
    GET_ALL_DEPARTMENTS_SUCCESS = '[DEPARTMENT] Get All Departments Success',
    GET_ALL_DEPARTMENTS_ERROR = '[DEPARTMENT] Get All Departments Error',
    UPDATE_DEPARTMENT = '[DEPARTMENT] Update Department',
    UPDATE_DEPARTMENT_SUCCESS = '[DEPARTMENT] Update Department Success',
    UPDATE_DEPARTMENT_ERROR = '[DEPARTMENT] Update Department Error',
    DELETE_DEPARTMENT = '[DEPARTMENT] Delete Department',
    DELETE_DEPARTMENT_SUCCESS = '[DEPARTMENT] Delete Department Success',
    DELETE_DEPARTMENT_ERROR = '[DEPARTMENT] Delete Department Error',
  }

  export const getAllDepartments = createAction(Type.GET_ALL_DEPARTMENTS);

  export const getAllDepartmentsSuccess = createAction(
    Type.GET_ALL_DEPARTMENTS_SUCCESS,
    props<{ departments: any }>()
  );

  export const getAllDepartmentsError = createAction(
    Type.GET_ALL_DEPARTMENTS_ERROR,
    props<{ error: any }>()
  );

  export const updateDepartment = createAction(
    Type.UPDATE_DEPARTMENT,
    props<{ installationId: string; departmentName: string }>()
  );

  export const updateDepartmentSuccess = createAction(Type.UPDATE_DEPARTMENT_SUCCESS);

  export const updateDepartmentError = createAction(
    Type.UPDATE_DEPARTMENT_ERROR,
    props<{ error: any }>()
  );

  export const deleteDepartment = createAction(
    Type.DELETE_DEPARTMENT,
    props<{ installationId: string }>()
  );

  export const deleteDepartmentSuccess = createAction(Type.DELETE_DEPARTMENT_SUCCESS);

  export const deleteDepartmentError = createAction(
    Type.DELETE_DEPARTMENT_ERROR,
    props<{ error: any }>()
  );
}
